import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const ProductCTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 bg-card/30">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-gradient-to-br from-card to-card/50 border border-border rounded-2xl p-8 md:p-10 lg:p-12 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-[0.02]">
            <div className="absolute inset-0" style={{
              backgroundImage: `linear-gradient(var(--color-primary) 1px, transparent 1px),
                               linear-gradient(90deg, var(--color-primary) 1px, transparent 1px)`,
              backgroundSize: '32px 32px'
            }} />
          </div>

          {/* Content */}
          <div className="relative z-10 text-center">
            {/* Heading */}
            <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
              Deploy Sleeve on Your Infrastructure
            </h2>

            {/* Description */}
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
              Platform-grade orchestration infrastructure for autonomous systems at industrial scale. Available for cloud, on-premises, or hybrid deployment configurations.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5 lg:gap-6">
              <Button
                variant="default"
                size="lg"
                iconName="Video"
                iconPosition="left"
                className="w-full sm:w-auto"
                onClick={() => navigate('/contact')}
              >
                Request a Live Platform Demo
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Layers"
                iconPosition="left"
                className="w-full sm:w-auto"
                onClick={() => navigate('/use-cases')}
              >
                See how teams apply Sleeve across industries
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCTASection;